import CartHelper from "@/utils/cart-helper"
export default class RequestTransformer{

  static collectPaymentExistingPaymentId(getters, payment_source_id) {
    var output = {
      currency_code: getters.currency_code,
      payment_source_id,
      amount: getters.amountToBePaid
    }

    Object.assign(output, this.flattenMulti(getters.selected_invoices.map(i => {
      return {invoice_id: i.id}
    }), 'invoice_allocations'));
    return output;
  }

  static collectPaymentNewSource(store, data, {replace_primary_payment_source, retain_payment_source}) {
    var output = {
      currency_code: store.getters.currency_code,
      amount: store.getters.amountToBePaid,
      replace_primary_payment_source,
      retain_payment_source
    }

    if(data.tmp_token) {
      data['payment_method[tmp_token]'] = data.tmp_token;
      delete data.tmp_token;
      data['payment_method[type]'] = data.type;
      delete data.type;
      Object.assign(output, this.createPaymentSourceUsingTmpToken(store.state, store.getters, data, replace_primary_payment_source, true));
    } else if(data.type == 'direct_debit' && !data.tmp_token) {
      Object.assign(output, this.createBankAccountPaymentSource(store.state, store.getters, data, replace_primary_payment_source, true));
    } else {
      Object.assign(output, this.createCardPaymentSource(store.state, store.getters, data, replace_primary_payment_source, true));
    }

    Object.assign(output, this.flattenMulti(store.getters.selected_invoices.map(i => {
      return {invoice_id: i.id}
    }), 'invoice_allocations'));

    return output;
  }

  static estimateRequest(state, rootState, getters) {
    var orderItem = state.cart.orderItems[0];
    var output = this.baseEstimateRequest(orderItem, getters);
    output["customer[vat_number]"] = getters.customer_data.vat_number;
    Object.assign(output,
            this.flatten(rootState.customer.billing_address, 'billing_address'),
            this.flatten(state.shipping_address, 'shipping_address'));

    return output;
  }

  static estimateRequestForCustomer(state, getters) {
    var orderItem = state.cart.orderItems[0];
    var output = this.baseEstimateRequest(orderItem, getters);

    Object.assign(output,
            this.flatten(state.shipping_address, 'shipping_address'));

    return output;
  }

  static estimateRequestForUpdateSubscription(state, rootState, getters) {
    var orderItem = state.cart.orderItems[0];
    var output = this.baseEstimateRequest(orderItem, getters);
    output["subscription[id]"] = getters.subscription_handle;

    Object.assign(output,
            this.flatten(state.shipping_address, 'shipping_address'));
    return output;
  }

  static baseEstimateRequest(orderItem, getters) {
    var output = {
      "subscription[plan_id]": orderItem.plan.id,
    }

    output["subscription[plan_quantity]"] = orderItem.plan.quantity;

    var addons = this.flattenMulti(orderItem.addons, 'addons');
    if(orderItem.coupon) {
      output["coupon_ids[0]"] = orderItem.coupon;
    }

    if(orderItem.replace_coupon_list) {
      output["replace_coupon_list"] = true;
    }

    if(orderItem.replace_addon_list) {
      output["replace_addon_list"] = true;
    }

    output["exclude_address_tax_calculation"] = getters.excludeAddressForTaxCalculation();

    return Object.assign(output, addons);
  }

  static baseSubscriptionRequest(orderItem) {
    var output = {
      plan_id: orderItem.plan.id,
      plan_quantity: orderItem.plan.quantity
    }

    var addons = this.flattenMulti(orderItem.addons, 'addons');
    if(orderItem.coupon) {
      output["coupon_ids[0]"] = orderItem.coupon;
    }

    if(orderItem.replace_coupon_list) {
      output["replace_coupon_list"] = true;
    }

    if(orderItem.replace_addon_list) {
      output["replace_addon_list"] = true;
    }

    return Object.assign(output, addons);
  }

  static updateSubscription(state) {
    return this.createSubscriptionForCustomer(state, true);
  }

  static createSubscriptionForCustomer(state, skipSubscriptionLevel, masterParams) {
    var output = {};
    var orderItem = state.order.cart.orderItems[0];
    Object.assign(output, this.baseSubscriptionRequest(orderItem));
    var addons = this.flattenMulti(orderItem.addons, 'addons');
    var shippingAddress = this.flatten(state.order.shipping_address, 'shipping_address');
    Object.assign(output, addons, shippingAddress, state.order.subscription);
    if(!skipSubscriptionLevel && state.order.pm_subscription_level) {
      Object.assign(output, {payment_source_id: state.order.payment_method.id});
    }
    Object.assign(output, {tos_agreed: state.order.tos_agreed});
    Object.assign(output, {"payless_checkout": state.config.recaptcha_checkout});
    if(masterParams) {
      Object.assign(output, {"recaptcha_response": masterParams.recaptcha_response});
    }
    Object.assign(output, {"auto_collection": (!state.config.recaptcha_checkout)? "On" : "off" })
    return output;
  }

  static createSubscription(state, masterParams) {
    var subscription = this.createSubscriptionForCustomer(state,true,masterParams);
    // May need to change the logic if bank account needs to be supported
    if(!state.config.recaptcha_checkout){
      if(state.order.payment_method.type == "card" && !state.order.payment_method.tmp_token) {
        Object.assign(subscription, this.flatten(state.order.payment_method, 'card'));
      } else if(state.order.payment_method.type == "direct_debit" && !state.order.payment_method.tmp_token) {
        Object.assign(subscription, this.flatten(state.order.payment_method, 'bank_account'));
      } else {
        Object.assign(subscription, this.flatten(state.order.payment_method, 'payment_method'));
      }
    }

    if(masterParams) {
      Object.assign(subscription, {"recaptcha_response": masterParams.recaptcha_response});
    }

    return Object.assign(subscription,
          this.flatten(state.customer.data, 'customer'),
          this.flatten(state.customer.billing_address, 'billing_address'),
          this.flatten(state.order.shipping_address, 'shipping_address'),
          { "payless_checkout": state.config.recaptcha_checkout },
          { "auto_collection": (!state.config.recaptcha_checkout)? "On" : "off" }
          );
  }


  static createCardPaymentSource(state, getters, data, replacePrimary, skipReplacePaymentSource) {
    var output = Object.assign(this.flatten(data, 'card'), {
      customer_id: state.auth.customer_handle
    });

    if(!skipReplacePaymentSource) {
      output["replace_primary_payment_source"] = replacePrimary || !getters.mpm_supported
    }

    return output;
  }

  static createBankAccountPaymentSource(state, getters, data, replacePrimary, skipReplacePaymentSource) {
    var output = Object.assign(this.flatten(data, 'bank_account'), {
      customer_id: state.auth.customer_handle
    });
    output["issuing_country"] = output["bank_account[issuing_country]"];
    delete output["bank_account[issuing_country]"];

    if(!skipReplacePaymentSource) {
      output["replace_primary_payment_source"] = replacePrimary || !getters.mpm_supported
    }

    return output;
  }

  static createPaymentSourceUsingTmpToken(state, getters, data, replacePrimary, skipReplacePaymentSource) {
    var output = Object.assign(data,{ customer_id: state.auth.customer_handle})

    if(!skipReplacePaymentSource) {
      output["replace_primary_payment_source"] = replacePrimary || !getters.mpm_supported
    }
    return output;
  }

  static updatePaymentMethod(data) {
    return this.flatten(data, 'payment_method');
  }

  static flattenMulti(items, name) {
    if(!items) return {};
    return items.reduce((o, item, index) => {
      // Rethink whether should we  whitelist params
      Object.keys(item).filter(i => ['id', 'quantity', 'invoice_id'].indexOf(i) > -1).forEach(keyName => {
        o[`${name}[${keyName}][${index}]`] = item[keyName];
      });
      return o;
    },{});
  }

  static flatten(data, name) {
    if(!data) return {};
    return Object.keys(data).reduce((o, key) => {
      o[`${name}[${key}]`] = data[key];
      return o;
    }, {});
  }


  static fetchResourceName(paramName) {
    if(paramName == "customer[vat_number]") {
      return "billing_address";
    }
    var matchedContents = paramName.match(/(.*)\[(.*)\]/);
    return matchedContents && matchedContents[1];
  }

  static fetchParamNameWithoutResource(paramName) {
    var matchedContents = paramName.match(/(.*)\[(.*)\]/);
    return (matchedContents && matchedContents[2]) || paramName;
  }

  static isNumber (value) {
    return typeof value === 'number' && !isNaN(Number(value));
  }

  static isDate(date) {
    let dateFormat = /^\d{4}-\d{2}-\d{2}$/
    return (dateFormat.test(date)) && (new Date(date) !== "Invalid Date") && !isNaN(new Date(date));
  }

  static getTimestampFromDate(d){
    if(this.isDate(d)){
      //should always return as Number
     return (new Date(d).getTime())/1000;
    }
    return d;
  }

  static getDateFromTimestamp(t) {
    let d = new Date(Number(t) * 1000);
    if(!!t && this.isNumber(t) && !isNaN(d)){
        return d.toISOString().slice(0,10);
    }
    return t;
  }
}


// WEBPACK FOOTER //
// ./src/utils/transformer.js